function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { trackEvent } from "/services/bigbrain-service";
import { SEGMENT_LAYOUT_NOT_FOUND, SEGMENT_NOT_VISIBLE_IN_VIEWPORT, SEGMENT_VISIBLE_IN_VIEWPORT } from "/constants/bigbrain-event-types";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";
import { getTheme, themes } from "segments/segments-service";
import Segments from "segments/desktop";
import classnames from "classnames";
import colors from "styles/colors";
import { SPACE_BLUE_COLOR_NAME } from "styles/color-consts";
import VisibilitySensor from "react-visibility-sensor";
import { hexToRgba, isServerSide } from "utils/general";
import { StyledBaseLayoutSegmentComponent, triangleHeightFactor } from "./base-layout-segment-component.scss";
import { COUNTRY_DISPLAY_MODE } from "segments/desktop/shared-advanced-fields-config";
import AssetComponent from "/components/core/asset/asset-component";
const shouldDisplayForSpecificCountry = (countrySpecificDisplaySettings, cloudfrontViewerCountry, isPreview)=>{
    if (isPreview || !(countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.countryDisplayMode) || !(countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.country)) {
        return true;
    }
    const { countryDisplayMode, country } = countrySpecificDisplaySettings;
    let isCountryIncluded;
    if (Array.isArray(country)) {
        const countries = country === null || country === void 0 ? void 0 : country.map((countryObject)=>countryObject.country);
        isCountryIncluded = countries === null || countries === void 0 ? void 0 : countries.includes(cloudfrontViewerCountry);
    } else {
        isCountryIncluded = country === cloudfrontViewerCountry;
    }
    return countryDisplayMode === COUNTRY_DISPLAY_MODE.INCLUDE ? isCountryIncluded : !isCountryIncluded;
};
const PERCENTAGE_REGEX = /^\d+(\.\d+)?%$/;
const getGradientThemeStyles = (gradientColors = [])=>{
    var _getTheme, _gradientColors_;
    return {
        background: `linear-gradient(180deg, ${gradientColors.map(({ color })=>{
            var _getTheme;
            const backgroundColor = (_getTheme = getTheme(color)) === null || _getTheme === void 0 ? void 0 : _getTheme.background;
            return backgroundColor ? `${hexToRgba(backgroundColor, 1)}` : "";
        }).join(", ")})`,
        color: (_getTheme = getTheme((_gradientColors_ = gradientColors[0]) === null || _gradientColors_ === void 0 ? void 0 : _gradientColors_.color)) === null || _getTheme === void 0 ? void 0 : _getTheme.color
    };
};
class BaseLayoutSegmentComponent extends PureComponent {
    getSegmentComponent() {
        var _Segments_segment_type;
        const { segment } = this.props;
        const segmentComponent = (_Segments_segment_type = Segments[segment.type]) === null || _Segments_segment_type === void 0 ? void 0 : _Segments_segment_type.component;
        if (!segmentComponent) {
            trackEvent(SEGMENT_LAYOUT_NOT_FOUND, {
                kind: segment.type
            });
            return false;
        }
        return segmentComponent;
    }
    getHtmlComponentElementFromDom() {
        const baseLayoutComponentClassName = this.getBaseLayoutComponentClassName();
        const ssrComponent = document.querySelector(`.${baseLayoutComponentClassName}`);
        return ssrComponent ? ssrComponent.innerHTML : null;
    }
    getSegmentStyle(segmentProps) {
        let { paddingTop, paddingBottom, segmentMinHeight } = segmentProps;
        const { isMobileOrTabletBrowser } = this.props;
        const { theme, gradientTheme, mobilePaddingTop, mobilePaddingBottom, baseLayoutStyleProps } = segmentProps;
        const themeStyles = (gradientTheme === null || gradientTheme === void 0 ? void 0 : gradientTheme.length) ? getGradientThemeStyles(gradientTheme) : themes[theme];
        if (isMobileOrTabletBrowser) {
            paddingTop = mobilePaddingTop || paddingTop;
            paddingBottom = mobilePaddingBottom || paddingBottom;
        }
        return _object_spread_props(_object_spread({}, themeStyles, baseLayoutStyleProps), {
            paddingTop,
            paddingBottom,
            minHeight: segmentMinHeight
        });
    }
    getBaseLayoutComponentClassName() {
        const { index } = this.props;
        return `base-layout-segment-component-${index}`;
    }
    getTriangleBorderStyle(triangle) {
        const color = colors[triangle === null || triangle === void 0 ? void 0 : triangle.color] || colors[SPACE_BLUE_COLOR_NAME];
        return `${100 * triangleHeightFactor}vw solid ${color}`;
    }
    render() {
        const { segment, isUserLoggedIn, extraProps, isMobileBrowser, dynamicProps, isPreview, cloudfrontViewerCountry } = this.props;
        const { isInView } = this.state;
        if (!segment) return null;
        const _segment_props = segment.props, { segmentId, hideOnMobile, showOnDevice, topTriangle, bottomTriangle, visibilitySensorProps, wrapInCard, sticky, countrySpecificDisplaySettings } = _segment_props, restSegmentProps = _object_without_properties(_segment_props, [
            "segmentId",
            "hideOnMobile",
            "showOnDevice",
            "topTriangle",
            "bottomTriangle",
            "visibilitySensorProps",
            "wrapInCard",
            "sticky",
            "countrySpecificDisplaySettings"
        ]);
        const { isSticky, stickyTopOffset } = sticky || {};
        const { useVisibilitySensor, visibilityOffset, easeInEffect } = visibilitySensorProps || {};
        if (showOnDevice) {
            if (showOnDevice === "mobile" && !isMobileBrowser) {
                return null;
            }
            if (showOnDevice === "desktop" && isMobileBrowser) {
                return null;
            }
        } else if (hideOnMobile && isMobileBrowser) {
            return null;
        }
        const SegmentComponent = this.getSegmentComponent();
        if (!SegmentComponent) return null;
        const SegmentComponentWithGenericConfig = withGenericConfig(SegmentComponent);
        const segmentStyle = this.getSegmentStyle(segment.props);
        const topTriangleBorderBottom = this.getTriangleBorderStyle(topTriangle);
        const bottomTriangleBorderTop = this.getTriangleBorderStyle(bottomTriangle);
        const parsedVisibilityOffset = this.getOffset(visibilityOffset);
        const shouldDisplaySegment = shouldDisplayForSpecificCountry(countrySpecificDisplaySettings, cloudfrontViewerCountry, isPreview);
        if (!shouldDisplaySegment) return null;
        return /*#__PURE__*/ _jsx(VisibilitySensor, {
            offset: {
                bottom: parsedVisibilityOffset || 0,
                top: parsedVisibilityOffset || 0
            },
            partialVisibility: true,
            onChange: this.onVisibilityChange,
            active: !!useVisibilitySensor,
            scrollCheck: !!useVisibilitySensor,
            children: /*#__PURE__*/ _jsxs(StyledBaseLayoutSegmentComponent, {
                cardBackgroundColor: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardBackgroundColor,
                cardBorderStyle: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardBorderStyle,
                cardWidth: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardWidth,
                cardPadding: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardPadding,
                stickyTopOffset: isSticky && stickyTopOffset,
                id: segmentId,
                className: classnames("base-layout-segment-component", {
                    sticky: !!isSticky
                }, {
                    "ease-in": easeInEffect
                }, {
                    "ease-in-animation": isInView && easeInEffect
                }, this.getBaseLayoutComponentClassName()),
                style: segmentStyle,
                children: [
                    (topTriangle === null || topTriangle === void 0 ? void 0 : topTriangle.isVisible) && /*#__PURE__*/ _jsx("div", {
                        className: classnames("triangle", "top", "bottom-left-corner"),
                        style: {
                            borderBottom: topTriangleBorderBottom
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: classnames("segment-wrapper", {
                            card: !!(wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.active)
                        }),
                        children: [
                            (wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardAsset) && /*#__PURE__*/ _jsx("div", {
                                className: "background-asset",
                                children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, wrapInCard.cardAsset))
                            }),
                            /*#__PURE__*/ _jsx(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, restSegmentProps), {
                                dynamicProps: dynamicProps,
                                isUserLoggedIn: isUserLoggedIn,
                                segmentType: segment.type,
                                isInView: isInView
                            }))
                        ]
                    }),
                    (bottomTriangle === null || bottomTriangle === void 0 ? void 0 : bottomTriangle.isVisible) && /*#__PURE__*/ _jsx("div", {
                        className: classnames("triangle", "bottom", "top-right-corner"),
                        style: {
                            borderTop: bottomTriangleBorderTop
                        }
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onVisibilityChange", (isVisible)=>{
            const { index, segment } = this.props;
            const visibilityEvent = isVisible ? SEGMENT_VISIBLE_IN_VIEWPORT : SEGMENT_NOT_VISIBLE_IN_VIEWPORT;
            const { visibilityOffset, useInfinitely } = segment.props.visibilitySensorProps || {};
            !useInfinitely && isVisible && this.setState({
                isInView: true
            });
            useInfinitely && this.setState({
                isInView: isVisible
            });
            trackEvent(visibilityEvent, {
                kind: segment.type,
                info1: visibilityOffset,
                info2: window.scrollY,
                placement: index
            });
        });
        _define_property(this, "getOffset", (offset)=>{
            const isOffsetInPercentages = PERCENTAGE_REGEX.test(offset);
            if (!isServerSide() && isOffsetInPercentages) {
                return parseInt(offset) / 100 * window.innerHeight;
            }
            return parseInt(offset);
        });
        this.state = {
            isInView: false
        };
    }
}
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
const BaseLayoutSegmentComponentContainer = (props)=>{
    const Component = props.isPreview ? withPreviewBaseSegment(BaseLayoutSegmentComponent) : withGenericConfig(BaseLayoutSegmentComponent);
    return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
};
export default BaseLayoutSegmentComponentContainer;
